import React, { useState } from 'react';

import BarChartHealthWrapper from '../barChartHealthWrapper/barChartHealthWrapper';
import MapChartHealthWrapper from '../mapChartHealthWrapper/mapChartHealthWrapper';
import LineChartHealthWrapper from '../lineChartHealthWrapper/lineChartHealthWrapper';

import ChartTitleIntro from '../chartTitleIntro/chartTitleIntro';
import AllQuestionButton from '../allQuestionsButton/allQuestionButton';
import DataMethodLink from '../dataMethodLink/dataMethodLink';

import Frage_1_Unterste_Einkommen_nominal from 'data/Frage-1_Unterste_Einkommen_nominal.json';
import Frage_1_Unterer_Mittelstand_nominal from 'data/Frage-1_Unterer_Mittelstand_nominal.json';
import Frage_1_Oberer_Mittelstand_nominal from 'data/Frage-1_Oberer_Mittelstand_nominal.json';
import Frage_1_Oberste_Einkommen_nominal from 'data/Frage-1_Oberste_Einkommen_nominal.json';

import Frage_1_Unterste_Einkommen_real from 'data/Frage-1_Unterste_Einkommen_real.json';
import Frage_1_Unterer_Mittelstand_real from 'data/Frage-1_Unterer_Mittelstand_real.json';
import Frage_1_Oberer_Mittelstand_real from 'data/Frage-1_Oberer_Mittelstand_real.json';
import Frage_1_Oberste_Einkommen_real from 'data/Frage-1_Oberste_Einkommen_real.json';

const ChartHealth1Wrapper = () => {
  const questionId = 1;
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const dataFilesNominal = [
    Frage_1_Unterste_Einkommen_nominal,
    Frage_1_Unterer_Mittelstand_nominal,
    Frage_1_Oberer_Mittelstand_nominal,
    Frage_1_Oberste_Einkommen_nominal,
  ];

  const dataFilesReal = [
    Frage_1_Unterste_Einkommen_real,
    Frage_1_Unterer_Mittelstand_real,
    Frage_1_Oberer_Mittelstand_real,
    Frage_1_Oberste_Einkommen_real,
  ];

  return (
    <div>
      <ChartTitleIntro number={questionId} title="Wie hoch ist die gesamte Umverteilung in der OKP?">
        <p>
          Hier wird die totale Umverteilung in der OKP für die vier Einkommensgruppen (unterste Einkommen, unterer Mittelstand, oberer Mittelstand,
          oberste Einkommen) dargestellt. Berücksichtigt werden alle Leistungsbezüge und Zahlungsströme. Weist eine Gruppe einen positiven Betrag auf,
          wird sie überdurchschnittlich belastet. Sie bezieht weniger Leistungen und/oder trägt mehr zur Finanzierung bei als der Durchschnitt. Und
          umgekehrt bedeutet ein negativer Betrag, dass diese Gruppe unterdurchschnittlich belastet wird.
        </p>
        <p>
          <em>
            Grafik 1.1 ermöglicht einen Vergleich zwischen den Einkommensgruppen innerhalb eines Kantons. Grafik 1.2 erlaubt einen interkantonalen
            Vergleich der Umverteilungswerte. In Grafik 1.3 ist die Entwicklung der Umverteilung über die Zeit abgebildet (real, zu Preisen des
            jüngsten verfügbaren Jahres). Hier erfahren Sie mehr zu <DataMethodLink />.
          </em>
        </p>
      </ChartTitleIntro>

      <div className="charttabs">
        <div className="charttabs-tabs uppercase">
          <div className={`charttabs-tab ${selectedTab === 0 ? 'active' : ''}`} onClick={() => setSelectedTab(0)}>
            {questionId}.1 Vergleich Einkommensgruppen
          </div>
          <div className={`charttabs-tab ${selectedTab === 1 ? 'active' : ''}`} onClick={() => setSelectedTab(1)}>
            {questionId}.2 Interkantonaler Vergleich
          </div>
          <div className={`charttabs-tab ${selectedTab === 2 ? 'active' : ''}`} onClick={() => setSelectedTab(2)}>
            {questionId}.3 Entwicklung über die Zeit
          </div>
        </div>
        <div className="charttabs-content">
          <div className={`${selectedTab === 0 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.1 GRUPPENVERGLEICH GESAMTUMVERTEILUNG OKP</div>
            <BarChartHealthWrapper dataFiles={dataFilesNominal} titlePrefix="Gesamtumverteilung OKP" />
          </div>
          <div className={`${selectedTab === 1 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.2 INTERKANTONALER VERGLEICH GESAMTUMVERTEILUNG OKP</div>
            <MapChartHealthWrapper dataFiles={dataFilesNominal} titlePrefix="Gesamtumverteilung OKP" />
          </div>
          <div className={`${selectedTab === 2 ? 'd-md-block' : 'd-md-none'}`}>
            <div className="charttabs-title d-md-none">{questionId}.3 ENTWICKLUNG GESAMTUMVERTEILUNG OKP</div>
            <LineChartHealthWrapper dataFiles={dataFilesReal} titlePrefix="Gesamtumverteilung OKP" />
          </div>
        </div>
      </div>
      <div className="d-md-none align-center">
        <AllQuestionButton />
      </div>
    </div>
  );
};

export default ChartHealth1Wrapper;
